module.exports = __webpack_public_path__ + "img/HG.b83a1680.png";